/**
 * Returns all cached async values.
 *
 * asyncCache = {[cacheKey]: {created: Date.now(), options: []}}
 *
 * @param {object} asyncCacheItems
 * @return {array}
 */
export const getAllCachedAsyncValues = asyncCacheItems => asyncCacheItems
    .reduce((memo, item) => ([...memo, ...item.options]), []);

/**
 * Returns option value.
 * Options can be complex or not.
 * complex option = {[labelKey]: label, [valueKey]: key}
 * simple option = Primitive
 *
 * @param {object|number|string} option
 * @param {string} optionKey - complex option key for key.
 * @return {*}
 */
export const getOptionValue = ({option, trackBy}) => (typeof option === 'object' ? option[trackBy] : option);

export const getPrimitiveValueFromValue = ({value, trackBy, multiple}) => {
    // returns empty value
    if (value === undefined || value === null) {
        return value;
    }
    if (multiple) {
        if (value) {
            // returns primitive values from values array
            return value.map(item => (typeof item === 'object' ? item[trackBy] : item));
        }
        // returns empty multiple value
        return value;
    }
    return typeof value === 'object' ? value[trackBy] : value;
};

/**
 * Returns option item value by primitive value and options list.
 *
 * @param {array} options
 * @param {string|number} value
 * @param trackBy
 * @return {*}
 */
export const findOptionByPrimitiveValue = ({
    options, value, trackBy,
}) => options
    .find(option => getOptionValue({
        option,
        trackBy,
    }) === value);
